import { setCheckoutOverlay } from "@/actions/ui";
import { triggerTransition } from "@uirouter/redux";
import { deleteReservation } from "@/actions/reservation";
import { refetchMember, setEmail, setName } from "@v/member/actions/member";
import request from "superagent";

export const setAuthStarted = (value) => ({ type: "SET_AUTH_STARTED", value })
export const loginPage = () => (dispatch, getState) => {
    const state = getState();
    const overlay = state.ui.overlay;

    if (!overlay) {
        dispatch(setCheckoutOverlay(true));
    }
    dispatch(triggerTransition('auth'));
};

export const login = (email: string, first_name: string = '', last_name: string = '') => (dispatch, getState) => {
    const state = getState();
    if (state.reservation?.token) {
        dispatch(refetchMember());
    }
    dispatch({ type: 'LOGIN', email, first_name, last_name });

    if(first_name !== '' && last_name !== '')
    {
        dispatch(setName(first_name + ' ' + last_name));
    }

    if(email !== '') {
        dispatch(setEmail(email));
    }
}

export const logout = () => (dispatch, getState) => {
    const { ui } = getState();

    const url = ui.styleVars.GLOBAL__PARTNER__URL + '/sso/logout';
    request.post(url)
        .set('Content-Type', 'application/json')
        .send()
        .then(res => {
            if ((res.body) && (res.body.success)) {
                dispatch(deleteReservation());
                dispatch({ type: 'LOGOUT' });
            }
        });
};

